export enum ExperienceProjectType {
    Construction = 0,
    FixFlipRehab = 1,
    Rental = 2,
    BuildToRent = 3,
    PersonalResidence = 4,
}

export const ExperienceProjectTypeOptions = [
    {
        id: ExperienceProjectType.Construction,
        name: 'Ground-Up New Construction',
        adminName: 'Construction',
    },
    {
        id: ExperienceProjectType.FixFlipRehab,
        name: 'Fix-Flip / Rehabilitation',
        adminName: 'Fix-Flip',
    },
    {
        id: ExperienceProjectType.Rental,
        name: 'Held for Rental Income',
        adminName: 'Rental',
    },
    {
        id: ExperienceProjectType.BuildToRent,
        name: 'Build-to-Rent',
        adminName: 'Build-Rent',
    },
    {
        id: ExperienceProjectType.PersonalResidence,
        name: 'Personal Residence',
        adminName: 'Personal Residence',
    },
];
